import { PureComponent } from 'react';
import get from 'transmute/get';
import userInfo from 'hub-http/userInfo';
import { AsyncStatusType } from 'calling-lifecycle-internal/utils/types/AsyncData';
import { fetchCallingAppealState } from 'calling-lifecycle-internal/calling-appeals/clients/fetchCallingAppealState';
import { PENDING } from '../constants/portalSuspension';
import { getAsyncAccountVerificationStatus } from '../operators/callingAccessGetters';
import getOrCreateCallingAccessStore from '../utils/getOrCreateCallingAccessStore';
import { logNetworkError } from 'calling-lifecycle-internal/utils/logNetworkError';
import produce from 'immer';
import { jsx as _jsx } from "react/jsx-runtime";
const withCallingAccess = Component => {
  const CALLING_ACCESS_SCOPE = 'calling-access';
  // Refactor: move away from immutables to arrays
  const getCallingAccessScope = scopes => Array.isArray(scopes) ? scopes.includes(CALLING_ACCESS_SCOPE) : !!scopes && !!get(CALLING_ACCESS_SCOPE, scopes);
  const JITA_USER_SCOPE = 'jita-user';
  const getJitaUserScope = scopes => Array.isArray(scopes) ? scopes.includes(JITA_USER_SCOPE) : !!scopes && !!get(JITA_USER_SCOPE, scopes);
  class Wrapper extends PureComponent {
    constructor(props) {
      super(props);
      this.getIsAccountVerificationStateUninitialized = () => {
        const callingAccess = this.callingAccessStore.getState();
        return getAsyncAccountVerificationStatus(callingAccess) === AsyncStatusType.UNINITIALIZED;
      };
      this.setInitialCallingAccess = scopes => {
        const hasCallingAccessScope = getCallingAccessScope(scopes);
        const hasJitaUserScope = getJitaUserScope(scopes);
        const result = {
          status: AsyncStatusType.SUCCEEDED,
          data: {
            hasCallingAccessScope,
            hasJitaUserScope
          },
          error: null
        };
        this.callingAccessStore.updateState(state => produce(state, draft => {
          draft.asyncCallingAccessScopes = result;
        }));
        const callingAccess = this.callingAccessStore.getState();
        this.setState({
          callingAccess
        });
      };
      this.fetchUserInfoAndSetInitialCallingAccess = () => {
        userInfo().then(data => {
          const scopes = data && data.user && data.user.scopes;
          this.setInitialCallingAccess(scopes);
        }).catch(networkError => {
          logNetworkError({
            error: new Error('Error fetching user info'),
            networkError
          });
          this.callingAccessStore.updateState(state => produce(state, draft => {
            draft.asyncCallingAccessScopes = {
              status: AsyncStatusType.FAILED,
              error: networkError,
              data: {
                hasCallingAccessScope: false,
                hasJitaUserScope: false
              }
            };
          }));
        });
      };
      this.setCallingAppealState = data => {
        const result = {
          status: AsyncStatusType.SUCCEEDED,
          data,
          error: null
        };
        this.callingAccessStore.updateState(state => produce(state, draft => {
          draft.asyncCallingAccessVerification = result;
          draft.hasAppealed = result.data.appealState === PENDING;
        }));
      };
      this.getCallingAppealState = () => {
        if (!this.getIsAccountVerificationStateUninitialized()) {
          return Promise.resolve();
        }
        return fetchCallingAppealState();
      };
      this.handleUpdatedState = ({
        instance: callingAccess
      }) => {
        this.setState({
          callingAccess: callingAccess.getState()
        });
      };
      this.callingAccessStore = getOrCreateCallingAccessStore();
      this.state = {
        callingAccess: this.callingAccessStore.getState()
      };
    }
    componentDidMount() {
      this.callingAccessStore.addListener(this.handleUpdatedState);
      if (!this.props.scopes) {
        this.fetchUserInfoAndSetInitialCallingAccess();
      } else {
        this.setInitialCallingAccess(this.props.scopes);
      }
      this.getCallingAppealState().then(appealStateResponse => {
        if (appealStateResponse) {
          this.setCallingAppealState(appealStateResponse);
        }
      }).catch(networkError => {
        logNetworkError({
          error: new Error('withCallingAccess failed'),
          networkError
        });
        this.callingAccessStore.updateState(state => produce(state, draft => {
          draft.asyncCallingAccessVerification = {
            status: AsyncStatusType.FAILED,
            error: networkError,
            data: {
              appealState: null,
              canAppeal: false,
              suspended: false
            }
          };
        }));
      });
    }
    componentWillUnmount() {
      this.callingAccessStore.removeListener(this.handleUpdatedState);
    }
    render() {
      const {
        callingAccess
      } = this.state;
      return /*#__PURE__*/_jsx(Component, Object.assign({}, this.props, {
        callingAccess: callingAccess
      }));
    }
  }
  Wrapper.displayName = 'WithCallingAccess';
  return Wrapper;
};
export default withCallingAccess;